// extracted by mini-css-extract-plugin
module.exports = {"cls1":"HookPage-SignatureList-module--cls1--t6xvg","cls2":"HookPage-SignatureList-module--cls2--29qUi HookPage-SignatureList-module--cls1--t6xvg"};